import getLocationByZip from '../core/get-location-by-zip';
import getLocationByIp from '../core/getLocationByIp';

/**
 * @private
 * Gets the promise with the postal code obtained by "geoIp" service.
 *
 * @return {Promise}
 */
function getPostal() {
  return getLocationByIp()
    .then(geoIp => geoIp.postal);
}

/**
  * @public
  * @param {String} zipCode override the zipCode
  * @return {Promise}
  */
function getGeoLocation(zipCode) {
  if (zipCode) {
    return getLocationByZip(zipCode);
  }

  return getPostal()
    .then((zipcode) => {
      if (!zipcode) throw new RangeError('No zipcode to request location');
      return zipcode;
    })
    .then(zipcode => getLocationByZip(zipcode));
}

/**
 * @public
 * Extends the `Applicant` object by setting the `GeoLocation` property.
 *
 * @param  {Object} applicant: Healthcare Applicant Object
 * @param {String} zipCode override the zipCode
 * @throws {RangeError} if no postal code matches with US zipcodes.
 * @return {Promise}
 */
function setGeoLocation(applicant, zipCode) {
  return getGeoLocation(zipCode)
    .then(geoLocation => Object.assign(applicant, { GeoLocation: geoLocation }));
}

/**
 * @public
 * Extends the `Applicant` object by setting `SizePage` property.
 *
 * @param  {Object} applicant: Healthcare Applicant Object
 * @param  {Number} sizePage: SizePage (how many plans to retrieve)
 * @return {Promise}
 */
function setSizePage(applicant, sizePage = 1) {
  return Object.assign(applicant, { SizePage: sizePage });
}

/**
 * API extendApplicant
 */
export default {
  setGeoLocation,
  setSizePage,
  getGeoLocation,
};
